
<div class="card bg-light">
  <div class="card-header card-header-clickable" (click)="isCollapsed=!isCollapsed">

    <div class="d-flex justify-content-start">

      <div class="">
        <span class="fa" [ngClass]="{'fa-chevron-up': isCollapsed, 'fa-chevron-down': !isCollapsed}" style="margin-right:10px"></span>
      </div>

      <div class="">
        <ng-content select="[re-cg-title-content]"></ng-content>
        <span *ngIf="title">{{title}}</span>

        <ng-template #tooltipTemplate>
        </ng-template>
        <span *ngIf="tooltip" class="ml-2 text-primary fa-solid fa-circle-info" placement="end" [ngbTooltip]="tooltip" tooltipClass="mfa-tooltip"></span>

      </div>

      <div class="ml-auto">
        <ng-content select="[re-cg-title-right-content]"></ng-content>
      </div>
    </div>


  </div>
  <div class="card-body" [ngbCollapse]="isCollapsed">
    <ng-content></ng-content>
  </div>
</div>



